import styled from '@emotion/styled';
import { MagicWandSvg } from './icons/MagicWand';
import { CloudSvg } from './icons/Cloud';

type IconType = keyof typeof typeToIcon;
const typeToIcon = {
  magicWand: <MagicWandSvg />,
  cloud: <CloudSvg />
};

export interface IconProps {
  type: IconType;
  size?: number;
  onClick?: (e?: React.MouseEvent) => void;
}

export const Icon: React.FC<IconProps> = ({ type, size, onClick }) => (
  <IconWrapper size={size} onClick={onClick}>
    {typeToIcon[type]}
  </IconWrapper>
);

const IconWrapper = styled('span', {
  shouldForwardProp: (prop) => prop !== 'size'
})<{ size?: number }>(
  ({ size }) => `
	display: inline-block;
	width: ${size | 24}px;
	height:  ${size | 24}px;
	line-height: 0; /* So the icon doesn't move a little lower */
	cursor: pointer;

		& > svg {
      width: 100%;
      height: 100%;
    }
`
);
